module.exports = __webpack_public_path__ + "static/img/kdic-competition.f524636.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/kdic-competition.jpg
// module id = 0qcH
// module chunks = 0